import React from 'react';
import { Grid, Chip, TextField, Typography } from '@mui/material';
import colors from '../../../styles/colors';
import useWindowSize from '../../../hooks/useWindowSize';

interface Product {
  id: string;
  label: string;
  icon: React.ReactNode;
  inputId: string;
  inputName: string;
  valueKey: string;
}

interface Props {
  product: Product;
  values: Record<string, any>;
  addProduct: (id: string) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  colors: typeof colors;
  colheitadeira: string;
}

export const ProductItem: React.FC<Props> = ({ product, values, addProduct, handleChange, colors, colheitadeira }) => {
  const isSelected = values.products.includes(product.id);
  const { width } = useWindowSize()
  const icon = product.id === '6'
    ? isSelected
      ? <img width={18} height={18} src={colheitadeira} alt="harvester" />
      : <img width={18} height={18} src="https://img.icons8.com/material-rounded/96/harvester.png" alt="harvester" />
    : product.icon;

  return (
    <Grid item md={4} sm={12} xs={12}>
      <Chip
        sx={{ marginX: 1, color: isSelected ? colors.IceWhite : colors.DarkerGray }}
        icon={icon as React.ReactElement}
        label={product.label}
        color={isSelected ? 'primary' : 'secondary'}
        onClick={() => addProduct(product.id)}
      />
      <Typography variant="body1">Quantidade</Typography>
      <TextField
        className="clientInput"
        fullWidth
        required
        disabled={!isSelected}
        type="number"
        sx={width > 1200 ? { width: 330 } : {}}
        id={product.inputId}
        name={product.inputName}
        placeholder="Informe um número de consultas aqui"
        value={values[product.valueKey]}
        onChange={handleChange}
      />
    </Grid>
  );
};
